<template>
  <v-list class="pb-0 pt-4 grey darken-4 list-progress">
    <v-subheader class="mb-0 pb-4">
      <v-progress-circular
        :size="48"
        :width="6"
        :rotate="270"
        :value="progressBarValue"
        color="success"
        class="mr-2 list-progress__bar"
      >
        {{ progressBarValue }}%
      </v-progress-circular>
      Complete your Account List:
    </v-subheader>
    <v-divider />
  </v-list>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState('recommendations', ['progress']),
      progressBarValue () {
        return this.progress ? this.progress : 0
      },
      progressBarStyle: function () {
        return {
          width: this.progress + '%',
          minWidth: '2em'
        }
      }
    }
  }
</script>

<style lang="stylus">
  .list-progress
    &__bar
      .v-progress-circular__underlay
        stroke: rgba(255,255,255,0.25)
</style>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/ProgressBar.vue